import { render } from "./ForumThread.vue?vue&type=template&id=4790a8a9&scoped=true"
import script from "./ForumThread.vue?vue&type=script&lang=js"
export * from "./ForumThread.vue?vue&type=script&lang=js"

import "./ForumThread.vue?vue&type=style&index=0&id=4790a8a9&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4790a8a9"]])

export default __exports__